import React, { useState, useEffect ,useRef} from 'react';
import Menu from 'react-burger-menu/lib/menus/slide';
import classnames from 'classnames';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Logo from '../../../Assets/Logo/logo-blue.svg';
import {BiWorld} from 'react-icons/bi';
import '../Header/Header.scss';
import { Collapse } from 'reactstrap';
import {AiOutlineBorderlessTable, AiOutlineBulb, AiOutlineCloud, AiOutlineCreditCard, AiOutlineFile, AiOutlineMail, AiOutlinePlayCircle, AiOutlineSearch, AiOutlineUser} from 'react-icons/ai';
import { BiCoinStack } from 'react-icons/bi';
import {MdAutorenew, MdLanguage} from 'react-icons/md';
import {FaParking} from 'react-icons/fa';
import {BsPencilSquare} from 'react-icons/bs';
import {
  IoIosAnalytics,
  IoIosArrowDown,
  IoIosApps,
  IoIosBasket,
  IoIosBookmark,
  IoIosCloudDone,
  IoIosCode,
  IoIosCube,
  IoIosFolderOpen,
  IoIosLink,
  IoIosPaperPlane,
  IoIosKey,
  IoMdShare,
  IoMdThunderstorm,
  IoMdMedal,
  IoMdMedkit,
  IoMdPricetag,
  IoMdLocate,
} from 'react-icons/io';
const nonMenuPages = ['/404'];

function ButtonHamburger({ isActive }) {
  const [color,setColor] = useState(false);
  const changeColor = () =>{
    if(window.scrollY >= 20){
      setColor(true);
    }else{
      setColor(false);
    }
  }
  window.addEventListener('scroll',changeColor);
  return (
    <button
    className={classnames('hamburger hamburger--collapse', {
      'is-active': isActive,
    })}
    type="button"
   
    >
      <span className="hamburger-box">
        <span className={color ? 'hamburger-inner active' : 'hamburger-inner'} />
      </span>
    </button>
  );
}

export function BurgerMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const [isCollapse1, setIsCollapse1] = useState(false);
    const [isCollapse2, setIsCollapse2] = useState(false);
    const [isCollapse3, setIsCollapse3] = useState(false);

  const location = useLocation();

  const closeMenu = () => setIsOpen(false);
  const prevScrollY = useRef(0);

  const [goingUp, setGoingUp] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY || window.scrollY < 70  ) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp && window.scrollY > 70  ) {
        setGoingUp(true);
      }
      prevScrollY.current = currentScrollY;
      console.log(goingUp, currentScrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);
  return (
    <div className="header">
    <Menu
      width={300}
      pageWrapId="page-wrap"
      outerContainerId="outer-container"
      isOpen={isOpen}
  
      customBurgerIcon={
        nonMenuPages.indexOf(location.pathname) !== -1 ? (
          false
        ) : (
          <ButtonHamburger isActive={isOpen} />
        )
      }
      id="slide"
      className={ `burger-menu ${goingUp === false && `burger-menu`} ${goingUp === true && `scrolled`} `}
      onStateChange={(state) => setIsOpen(state.isOpen)}
    >
      {/* This div is very important. This make all of event on inner elements is not affected by package Burger Menu */}
      <div className="menu">
        <h1 className="logo">
          <Link to="/" className="logo__image">
            <img src={Logo} />
          </Link>
        </h1>
        {/* <Link to="/Support" className="menu__item" onClick={closeMenu}>
        Products
        </Link>
        <Link to="/Support" className="menu__item" onClick={closeMenu}>
        Pricing
        </Link>
        <Link to="/Support" className="menu__item" onClick={closeMenu}>
         Enterprise
        </Link>
        <Link to="/Apps" className="menu__item" onClick={closeMenu}>
        Apps
        </Link>
        <Link to="/Support" className="menu__item" onClick={closeMenu}>
        Blog And More
        </Link> */}
        <div
          className={classnames('menu__item', { 'menu__item--active': !!isCollapse1 })}
          onClick={() => setIsCollapse1(!isCollapse1)}
        >
          Product <IoIosArrowDown />
        </div>
        <Collapse isOpen={isCollapse1}>
          <nav className="submenu" style={{display:isCollapse1 ? "block" : "none"}} >
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/collaboration"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineBulb/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Collaboration</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/wireframe"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineCloud/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Wireframing</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/prototyping"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <BiCoinStack />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Prototype</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/usability-testing"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineCreditCard />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Usability Testing</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/why"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <FaParking/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Why HostDesign</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/customer-stories"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlinePlayCircle />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Customers-stories</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/help-center"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineBorderlessTable />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Help Center</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/blog"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <MdAutorenew />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Blog</p>
              </div>
            </NavLink>
           
          </nav>
        </Collapse>
        <Link to="/pricing" className="menu__item" onClick={closeMenu}>
        Pricing
        </Link>
        <Link to="/Enterprise" className="menu__item" onClick={closeMenu}>
        Enterprise
        </Link>
        <Link to="/Blog" className="menu__item" onClick={closeMenu}>
        Blog
        </Link>


        <div
          className={classnames('menu__item', { 'menu__item--active': !!isCollapse2 })}
          onClick={() => setIsCollapse2(!isCollapse2)}
        >
         About <IoIosArrowDown />
        </div>
        <Collapse isOpen={isCollapse2}>
          <nav className="submenu" style={{display:isCollapse2 ? "block" : "none"}} >
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/about-us"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineBulb/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">About Us</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/status"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineCloud/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Status</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/security"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <BiCoinStack />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Security</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/resources"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineCreditCard />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Resources</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/jobs"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <FaParking/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Jobs</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/ebooks"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlinePlayCircle />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">eBooks</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/webinars"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineBorderlessTable />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Webinars</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/product-updates"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <MdAutorenew />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Product Updates</p>
              </div>
            </NavLink>
           
          </nav>
        </Collapse>
        
        <div
          className={classnames('menu__item', { 'menu__item--active': !!isCollapse3 })}
          onClick={() => setIsCollapse3(!isCollapse3)}
        >
         Apps <IoIosArrowDown />
        </div>
        <Collapse isOpen={isCollapse3}>
          <nav className="submenu" style={{display:isCollapse3 ? "block" : "none"}} >
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/desktop"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineBulb/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Desktop</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/android-phone"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineCloud/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Android Phone</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/android-pad"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <BiCoinStack />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">Android Pad</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/imac-app"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlineCreditCard />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">iMac</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/mobile-app"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <FaParking/>
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">iPhone</p>
              </div>
            </NavLink>
            <NavLink
              onClick={closeMenu}
              activeClassName="is-active"
              to="/ipad-app"
              className="submenu__link"
            >
              <div className="submenu__sub-box-icon">
                <AiOutlinePlayCircle />
              </div>
              <div className="submenu__sub-box-content">
                <p className="submenu__sub-subtitle">iPad</p>
              </div>
            </NavLink>
     
      
           
          </nav>
        </Collapse>
        <div className="auth-menu-mobile">
        
     
        <Link to='/login' className='auth__btn '>
      <button className='button-unstyled auth__btn--login loginbtn'>Log In</button>
    </Link>
    <Link to='/signup' className='auth__btn'>
      <button className='button-primary-hover auth__btn--signup'>
        Sign Up
      </button>
    </Link>
      </div>
      </div>
    </Menu>
    </div>
  );
}
